// John Eldhose 20180601
import { RestfulGet } from './Restful';

export async function ManageAccountPP() {
  const com = await RestfulGet('ManageAccountPP', (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return com;
}



// WEBPACK FOOTER //
// ./src/Api/ManageAccountPP.js